import React from "react";
import { motion } from "framer-motion";
import { crmBusinessImpact } from "../../data/crmPageContent";
import { useCountUp } from "../../hooks/useCountUp";
import { useInView } from "../../hooks/useInView";
import { CrmReveal } from "./CrmMotion";

const ImpactStat = ({
    value,
    suffix,
    label,
    active,
}: {
    value: number;
    suffix: string;
    label: string;
    active: boolean;
}) => {
    const count = useCountUp(value, 1800, active);
    return (
        <motion.div className="crm-impact__stat" whileHover={{ y: -6, scale: 1.02 }}>
            <div className="crm-impact__num">
                {count}
                {suffix}
            </div>
            <div className="crm-impact__lbl">{label}</div>
        </motion.div>
    );
};

export const CrmBusinessImpactSection = () => {
    const { ref, isInView } = useInView(0.25);

    return (
        <section className="crm-impact" ref={ref}>
            <div className="crm-container">
                <CrmReveal className="crm-impact__header">
                    <h2 className="crm-h2">Results That Speak for Themselves</h2>
                    <div className="crm-section-accent crm-section-accent--center" />
                    <p className="crm-lead">
                        Teams using HonestiIQ see measurable improvements across response time,
                        visibility, efficiency, and customer satisfaction.
                    </p>
                </CrmReveal>

                <div className="crm-impact__grid">
                    {crmBusinessImpact.map((s) => (
                        <ImpactStat key={s.label} {...s} active={isInView} />
                    ))}
                </div>
            </div>
        </section>
    );
};
